module.exports = __webpack_public_path__ + "media/images/toggle-off-icon-4a13d1f52d7594ee4fd5a9344c185a5d.png";